import {React, useEffect, useState} from 'react'
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import axios from "axios";
import { API_URL } from '../../api-config';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

const ChangePassword = () => {
  const {email, valid_token } = useParams();
  const [password, setPassword] = useState("");
  const [secondPassword, setSecondPassword] = useState("");
  const [validToken, setValidToken] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email) {
      setErrorMessage('El email no pertenece a una cuenta.');
      return;
    } else if (!valid_token) {
      setErrorMessage('No se tienen los permisos para realizar el cambio');
      return;
    }
    if (password !== secondPassword && password !== "" && secondPassword !== "") {
      setErrorMessage('Las contraseñas no coinciden.');
      return;
    } else if (password === "" || secondPassword === "") {
      setErrorMessage('Las contraseñas no pueden estar vacías.');
      return;
    }

    const body = {
      password: password,
    }

    try{
      const response = await axios.patch(`${API_URL}/users/change_pass`, body, {
        headers: {
          "accept": "application/json",
          "Authorization": "Bearer " + valid_token,
        }
      })
      console.log("Response: ", response);
      toast.success('Se ha cambiado tu contraseña', {
        position: toast.POSITION.TOP_RIGHT
      });
      window.location.assign("/");
    } catch(error) {
      console.log(`Error: ${error}`);
      setErrorMessage('No se pudo actualizar tu contraseña. Inténtelo de nuevo.');
    }
  };

  useEffect(() => {
    async function verifyToken() {
      try{
        await axios.get(`${API_URL}/users/validate_token`, {
          headers: {
            "accept": "application/json",
            "Authorization": "Bearer " + valid_token,
          }
        })
        setValidToken(true);
      } catch(error) {
        window.location.assign("/");
      }
    }
    if (validToken === false){
      verifyToken();
    }
  }, [valid_token]);

  useEffect(() => {
    async function getUser() {
      try{
        await axios.get(`${API_URL}/users/email?email=${email}`)
        setValidEmail(true);
      } catch(error) {
        window.location.assign("/");
      }
    }
    if (validEmail === false){
      getUser();
    }
  }, [email]);

  return (
    <>
      {validToken === false && validEmail === false ?
        null :
        <div>
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }} id="qrt-icon">
                QRT
              </Avatar>
              <Typography component="h1" variant="h2">
                Actualización de contraseña
              </Typography>
              <br></br>
              <Typography component="h1" variant="h4">
                Ingresa tu nueva contraseña
              </Typography>
              <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1  }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="password"
                  variant='filled'
                  label="Nueva Contraseña"
                  name="password"
                  onChange={(e)=> setPassword(e.target.value)}
                  autoComplete="password"
                  autoFocus
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="password"
                  variant='filled'
                  label="Confirmar Contraseña"
                  name="password"
                  onChange={(e)=> setSecondPassword(e.target.value)}
                  autoComplete="password"
                  autoFocus
                />
                
                {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  id="signup-button"
                >
                  Cambiar Contraseña
                </Button>
              </Box>
            </Box>
          </Container>
        </div>
      }
    </>
  )
}

export default ChangePassword
